import React from 'react'
import SaveBtn from './saveBtn';
import { Link } from 'react-router-dom';
import { TiArrowSortedDown, TiArrowSortedUp } from "react-icons/ti";




const TrendTable = ({ data }) => {
    data[0] ? console.log(data[0]) : console.log('')
    return (
        <table className="w-full min-w-max">
            <thead
                className="capitalize text-base text-white-100 
            font-medium border-b border-gray
            "
            >
                <tr className="text-sm lg:text-md">
                    <th className="py-1 text-left"> </th>
                    <th className="py-1 px-1 text-left">#</th>
                    <th className="py-1 px-1 text-left">name</th>
                    {/* <th className="py-1 px-1 text-left block lg:hidden"></th> */}
                    <th className="py-1 text-left">price</th>
                    <th className="py-1 text-left lg:table-cell hidden">total volume</th>
                    <th className="py-1 text-left lg:table-cell hidden">market cap</th>
                    {/* <th className="py-1 text-left lg:table-cell hidden">1H</th> */}
                    <th className="py-1 text-left">24H</th>
                    {/* <th className="py-1 text-left lg:table-cell hidden">7D</th> */}

                </tr>
            </thead>
            <tbody>
                {data.map((data, index) => {
                    return (
                        <tr
                            key={data.item.id}
                            className="text-center text-base border-b border-gray
            hover:bg-gray-200 last:border-b-0 text-sm lg:text-md
            "
                        >
                            <td><SaveBtn data={data.item} /></td>
                            <td className="py-4 flex items-center uppercase">

                                <span>
                                    <Link to={`/${data.item.id}`} className="cursor-pointer">
                                        <b>{data.item.market_cap_rank}</b>
                                    </Link>
                                </span>
                            </td>
                            <td className="py-4 item-center">

                                <Link to={`/${data.item.id}`} className="cursor-pointer">
                                    <span style={{ display: "flex" }}><img
                                        className="w-[1.5rem] h-[1.5rem] mx-1.5"
                                        src={data.item.small}
                                        alt={data.item.name}
                                    />
                                        <b><span className="hidden sm:inline">{data.item.name}</span> &nbsp; <span><b className="uppercase"> {data.item.symbol}</b></span></b>

                                    </span>
                                </Link>
                            </td>

                            <td className="py-4 flex item-center">
                                {/* <b>${new Intl.NumberFormat("en-IN", {
                                }).format(data.current_price)}</b> */}
                                
                                {data.item.data.price > 1 ? <b>${data.item.data.price.toLocaleString()}</b> : <b>${data.item.data.price.toFixed(10)}</b> }
                            </td>

                            <td className="py-4 text-left lg:table-cell hidden"><b>{data.item.data.total_volume}</b></td>

                            <td className="py-4 flex item-center text-left lg:table-cell hidden">
                                <b>{data.item.data.market_cap}</b>
                            </td>
                            {/* <td
                                className={
                                    data.price_change_percentage_1h_in_currency > 0
                                        ? "text-left text-green py-4 lg:table-cell hidden"
                                        : "text-left text-red py-4 lg:table-cell hidden"
                                }
                            >
                                <b>{Number(
                                    data.price_change_percentage_1h_in_currency
                                ).toFixed(2)}</b>
                            </td> */}

                            <td
                                className={
                                    data.item.data.price_change_percentage_24h.usd > 0
                                        ? "text-left text-green py-4 "
                                        : "text-left text-red py-4"
                                }
                            >
                                <span className='inline-flex items-center'>
                                    {data.item.data.price_change_percentage_24h.usd > 0 ? (
                                        <TiArrowSortedUp className="mr-1" />
                                    ) : (
                                        <TiArrowSortedDown className="mr-1" />
                                    )}
                                    <b>{Number(
                                        data.item.data.price_change_percentage_24h.usd
                                    ).toFixed(2)}</b>
                                </span>
                            </td>
                            {/* <td
                                className={
                                    data.price_change_percentage_7d_in_currency > 0
                                        ? "text-left text-green py-4 lg:table-cell hidden"
                                        : "text-left text-red py-4 lg:table-cell hidden"
                                }
                            >
                                
                                <b>{Number(
                                    data.price_change_percentage_7d_in_currency
                                ).toFixed(2)}</b>
                            </td> */}
                        </tr>
                    );
                })}
            </tbody>
        </table>
    )
}


export default TrendTable;